export default function PlatformHero() {
  return (<>
      <section className="hero section-space">
        <div className="hero-glow hero-glow-one"></div>
        <div className="hero-glow hero-glow-two"></div>
        <div className="container hero-grid">
          <div className="hero-copy reveal">
            <div className="eyebrow">{"DIGITAL OPERATIONS, MANAGED."}</div>
            <h1>{"Everything your digital business needs."}<br /><span>{"One platform. One team."}</span></h1>
            <p className="hero-lead">{"\n              Build, run, support and scale your business with ready-to-use software and managed technology services.\n              From development, DevOps, QA and cybersecurity to customer support, payments, CRM, WhatsApp automation,\n              booking and order management — activate what you need and scale when you need it.\n            "}</p>
            <div className="hero-actions">
              <a className="btn btn-primary btn-lg" href="#platform">{"Explore Solutions"}</a>
              <a className="btn btn-dark btn-lg" href="#pricing">{"Start for Free"}</a>
              <a className="hero-text-link" href="#contact">{"Talk to an Expert "}<span>{"→"}</span></a>
            </div>
            <div className="trust-line">
              <span>{"✓ No long-term lock-in"}</span>
              <span>{"✓ Flexible monthly plans"}</span>
              <span>{"✓ Global delivery"}</span>
              <span>{"✓ Managed by real experts"}</span>
            </div>
          </div>

          <div className="hero-visual reveal delay-1" aria-label="Platform architecture illustration">
            <div className="visual-window">
              <div className="visual-topbar">
                <div className="window-dots"><i></i><i></i><i></i></div>
                <span>{"Digital Operations Platform"}</span>
                <span className="status-pill">{"Live"}</span>
              </div>
              <div className="business-node">{"YOUR BUSINESS"}</div>
              <div className="connector vertical"></div>
              <div className="platform-core">
                <div className="core-title">{"ONESTACK PLATFORM"}</div>
                <div className="core-grid">
                  <div className="core-item"><span className="icon-badge">{"↗"}</span><b>{"Build"}</b><small>{"Software & APIs"}</small></div>
                  <div className="core-item"><span className="icon-badge">{"⌁"}</span><b>{"Operate"}</b><small>{"DevOps & Cloud"}</small></div>
                  <div className="core-item"><span className="icon-badge">{"⌘"}</span><b>{"Secure"}</b><small>{"QA & Security"}</small></div>
                  <div className="core-item"><span className="icon-badge">{"$"}</span><b>{"Payments"}</b><small>{"Accept & Reconcile"}</small></div>
                  <div className="core-item"><span className="icon-badge">{"◉"}</span><b>{"Engage"}</b><small>{"CRM & Support"}</small></div>
                  <div className="core-item"><span className="icon-badge">{"✦"}</span><b>{"Automate"}</b><small>{"AI & Workflows"}</small></div>
                </div>
              </div>
              <div className="visual-footer-row">
                <div className="mini-card"><strong>{"99.98%"}</strong><span>{"System health"}</span></div>
                <div className="mini-card"><strong>{"24/7"}</strong><span>{"Managed coverage"}</span></div>
                <div className="mini-card"><strong>{"1"}</strong><span>{"Unified control center"}</span></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="logo-strip">
        <div className="container">
          <p>{"Designed for modern teams using"}</p>
          <div className="logo-row">
            <span>{"AWS"}</span><span>{"AZURE"}</span><span>{"GOOGLE CLOUD"}</span><span>{"GITHUB"}</span><span>{"DOCKER"}</span><span>{"WHATSAPP"}</span><span>{"SHOPIFY"}</span>
          </div>
          <small>{"Integration compatibility references only. No partnership implied."}</small>
        </div>
      </section>

  </>);
}
